export var WaiverType;
(function (WaiverType) {
    WaiverType["Payment"] = "PAYMENT";
    WaiverType["Main"] = "MAIN";
    WaiverType["Custom"] = "CUSTOM";
})(WaiverType || (WaiverType = {}));
